import { TStatisticsPortalStoreState } from './types';

export function getVisitsCountByTimeTable(state: TStatisticsPortalStoreState) {
  return state.visitsCountByTimeTable;
}

export function getVisitsCountByGroupsTable(state: TStatisticsPortalStoreState) {
  return state.visitsCountByGroupsTable;
}

export function getVisitsCountByUsersTable(state: TStatisticsPortalStoreState) {
  return state.visitsCountByUsersTable;
}

export function getAverageVisitsTimeTable(state: TStatisticsPortalStoreState) {
  return state.averageVisitsTimeTable;
}

export function getViewsCountByTimeTable(state: TStatisticsPortalStoreState) {
  return state.viewsCountByTimeTable;
}

export function getPagesTable(state: TStatisticsPortalStoreState) {
  return state.pagesTable;
}

export function getSectionsTable(state: TStatisticsPortalStoreState) {
  return state.sectionsTable;
}

export function getUniqueVisitsCountTable(state: TStatisticsPortalStoreState) {
  return state.uniqueVisitsCountTable;
}

export function getViewsCountByTimeChartData(state: TStatisticsPortalStoreState) {
  return state.viewsCountByTimeChartData;
}

export function getUniqueVisitsCountChartData(state: TStatisticsPortalStoreState) {
  return state.uniqueVisitsCountChartData;
}

export function getAverageVisitsTimeChartData(state: TStatisticsPortalStoreState) {
  return state.averageVisitsTimeChartData;
}

export function getVisitsCountByTimeChartData(state: TStatisticsPortalStoreState) {
  return state.visitsCountByTimeChartData;
}
